import React from 'react';
import { InfoBadge } from './InfoBadge';
import { getTransferTypeMeta } from '../../utils/transferTypeMeta';

/**
 * Identity/category chip for `AssetTransfer.transfer_type`.
 *
 * Per DS "Badge & Status Indicators":
 *   - workflow status -> <StatusBadge>
 *   - identity / category -> <InfoBadge>
 * `transfer_type` is identity ("what kind of transfer happened?"), not
 * workflow status (the transfer's status field — pending/completed/etc. —
 * is rendered separately by <StatusBadge>).
 *
 * This component is intentionally a thin wrapper around <InfoBadge> so all
 * sizing / color tokens / focus-ring rules from the DS apply automatically.
 *
 * @param {string} type - transfer_type enum value (e.g. 'termination',
 *                        'initial', 'transfer'). Unknown values render as
 *                        a neutral "Unknown" chip rather than leaking the
 *                        raw enum string into the UI.
 * @param {'xs'|'md'} [size] - Inherited from InfoBadge.
 * @param {string} [className] - Extra layout classes (margins, etc.).
 */
export const TransferTypeBadge = ({ type, size, className }) => {
  const { label, color } = getTransferTypeMeta(type);
  return <InfoBadge color={color} label={label} size={size} className={className} />;
};

export default TransferTypeBadge;
